var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.resolveLayoutVariant,{tag:"component",class:`skin-variant--${_vm.appSkinVariant}`},[_c('transition',{attrs:{"name":_vm.appRouteTransition,"mode":"out-in","appear":""}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }